// Which assistant this app shows (Shohini, 9 Oct 2026: ONE assistant).
//
//   'shared'  the EquaOS assistant: Hiring's tools, agents and read-back
//             cards, the same assistant as every other EquaOS app.
//   'copilot' the older Copilot panel, only while the server has
//             COPILOT_PANEL=on (kept for one release, to switch back).
//   null      not known yet, or inside the ERP shell, whose own assistant
//             is already on screen.
//
// The server decides (GET /api/copilot/status → panel), so switching back
// needs no new build.

import { useEffect, useState } from 'react';
import { copilotStatus } from '../../services/copilot.service';
import { inShell } from '../../shell';

export default function useAssistantChoice() {
  const [choice, setChoice] = useState(null);
  useEffect(() => {
    if (inShell) return undefined;
    let gone = false;
    copilotStatus()
      .then((s) => { if (!gone) setChoice(s && s.panel === true ? 'copilot' : 'shared'); })
      .catch(() => { if (!gone) setChoice('shared'); });
    return () => { gone = true; };
  }, []);
  return choice;
}
